import React, { useState } from "react";
import FormField from "./FormField";
import MyButton from "./MyButton";
import RowColLayout from "./RowColLayout";

/**
 * fields: array of field definitions
 * formData: object with field values
 * errors: object with field errors
 * handleChange: function to update form values
 * handleSubmit: form submit handler
 * dropdowns: optional dropdown options keyed by field name
 * buttonConfig: { mainText, secondaryText?, onSecondaryClick?, loading?, loadingText? }
 * columns: number of columns on medium+ screens (default 2)
 */
export default function FormRenderer({
  fields,
  formData,
  errors,
  handleChange,
  handleSubmit,
  dropdowns = {},
  buttonConfig = null,
  selectorMap = {},
  columns = 2,
  showToplabel = false,
  icon
}) {

  const [showPassword, setShowPassword] = useState(false);
  // Determine Bootstrap column class based on columns prop
  const colClass = `form-renderer col-11 col-md-${Math.floor(12 / columns)} d-flex justify-content-center mx-3 p-0`;

  return (
    <RowColLayout>
      <form onSubmit={handleSubmit}>
        <div className="row d-flex justify-content-center align-items-center">
          {fields.map((field) => (
            <div key={field.name} className={colClass}>
              <div style={{ position: 'relative', width: '100%' }}>
  <FormField
    {...field}
    value={formData[field.name]}
    hasError={Boolean(errors[field.name])}
    onChange={handleChange}
    options={dropdowns[field.name] || undefined}
    selector={selectorMap[field.name]}
    type={field.name === 'password' ? (showPassword ? 'text' : 'password') : field.type}
    showToplabel={showToplabel}
    icon={icon} // ✅ pass icon here
  />
  {field.name === 'password' && (
    <button
      type="button"
      onClick={() => setShowPassword(!showPassword)}
      style={{
        position: 'absolute',
        right: 10,
        top: '30%',
        transform: 'translateY(-50%)',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '8px',
      }}
    >
      {showPassword ? '👁️' : '🚫'}
    </button>
  )}
</div>
            </div>
          ))}
        </div>

      {buttonConfig && (
        <RowColLayout className="mt-3">
          <MyButton
            text={
              buttonConfig.loading
                ? buttonConfig.loadingText
                : buttonConfig.mainText
            }
            type="submit"
            disabled={buttonConfig.disabled}
          />
          {buttonConfig.secondaryText && buttonConfig.onSecondaryClick && (
            <MyButton
              text={buttonConfig.secondaryText}
              variant="primary"
              onClick={buttonConfig.onSecondaryClick}
            />
          )}
        </RowColLayout>
      )}

      </form>
    </RowColLayout>
  );
}
